import React, { useEffect } from 'react'

import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import { alertsSection, isRatingTabLoading } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import RatingTable from "Pages/ReportsAlerts/Alerts/Conditions/Rating/Table"
import RatingDrawer from "Pages/ReportsAlerts/Alerts/Conditions/Rating/Drawer"
import { BACKEND_APIS } from "@constants"
import { isTourDemoActive } from "@signals/app"


export default function RatingBlock() {

	const {
		getTableData,
		tableData,
		onDeleteAlert,
		isTableLoading,
		isAlertSubmitting,
		onEditAlert,
		onSubmitAlert,
		filterConditions
	} = useAlertsTableData(`${BACKEND_APIS.CONDITIONS}/rating`)

	useEffect(() => {
		isRatingTabLoading.value = true
		getTableData()
			.then(() => isRatingTabLoading.value = false)
			.catch(() => isRatingTabLoading.value = false)
	}, [])

	if (alertsSection.value !== ALERTS.RATING) return <></>

	return <>
		{!(isTourDemoActive.value && !tableData?.length) && <RatingTable
			isLoading={isTableLoading}
			data={tableData}
			onDeleteAlert={onDeleteAlert}
			onEditAlert={onEditAlert}
			filterConditions={filterConditions}
		/>}
		<RatingDrawer onSubmitAlert={onSubmitAlert} isLoading={isAlertSubmitting}/>
	</>
}